import { ComponentLocatorMap } from '../types/ComponentLocatorMap';

export const employmentSectionComponent = {
  amount: 'employment-section.amount',
  duration: 'employment-section.duration',
  editLink: 'employment-section.edit-link',
  h3: 'employment-section.h3',
  incomeType: 'employment-section.income-type',
  root: 'employment-section.root',
  status: 'employment-section.status',
} as const satisfies ComponentLocatorMap;
